module.exports = "<div class=\"modal-content help-modal\">\n  <form name=\"form\" novalidate class=\"css-form\">\n    <div class=\"modal-body\" id=\"modal-body\">\n      <div>\n        <h3>Session will expire soon, to continue click OK.</h3>\n      </div>\n      <div class=\"modal-footer\">\n        <button class=\"btn button-plain\" type=\"button\" ng-click=\"$ctrl.ok()\">OK</button>\n      </div>\n    </div>\n  </form>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/session-notification/session-notification-modal.html
// module id = 627
// module chunks = 0